import { useEffect } from 'react';
import { useUser } from '../context/UserContext';
function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

export default function Dashboard() {
	const { user } = useUser();

	const projects = [
		{
			name: 'Messages',
			initials: 'M',
			href: '/admin/messages',
			members: 16,
			bgColor: 'bg-pink-600',
		},
		{
			name: 'Blog Posts',
			initials: 'B',
			href: '/admin/blog',
			members: 12,
			bgColor: 'bg-purple-600',
		},
		{
			name: 'Customers',
			initials: 'C',
			href: '/admin/customers',
			members: 16,
			bgColor: 'bg-yellow-500',
		},
		{
			name: 'Keywords',
			initials: 'K',
			href: '/admin/keywords',
			members: 0,
			bgColor: 'bg-green-500',
		},
	];

	useEffect(() => {
		if (window.tm)
			window.tm.event('pageView', 'Admin:Dashboard', {
				page: {
					pageInfo: {
						sysEnv: window.navigator.userAgent.includes('Mobile') ? 'mobile' : 'desktop',
						variant: 'A',
						version: '1.0',
					},
				},
			});
	}, []);
	return (
		<div className='px-16 py-10'>
			<h2 className='text-sm font-medium text-gray-500'>Welcome, {user.name || 'User'}</h2>
			<ul
				role='list'
				className=' *:mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4'
			>
				{projects.map((project) => (
					<li
						key={project.name}
						className='col-span-1 flex rounded-md shadow-sm'
					>
						<div
							className={classNames(
								project.bgColor,
								'flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white'
							)}
						>
							{project.initials}
						</div>
						<div className='flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white'>
							<a
								href={project.href}
								className='font-medium text-gray-900 hover:text-gray-600'
							>
								<div className='flex-1 truncate px-4 text-sm py-3'>{project.name}</div>
							</a>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
}
